// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cards__list,\n.cards__total {\n  font-family: \"Roboto\", Arial, sans-serif;\n}\n.cards__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  grid-auto-rows: 200px;\n  grid-gap: 10px;\n}\n.cards__total {\n  font-size: 42px;\n}", ""]);
// Exports
module.exports = exports;
